import { AppResponse } from '../../../api/models/app-response';
import { DEMO_CUSTOMER_PROFILE_ID } from '../demo-jwt';

const NOW_ISO = new Date().toISOString();
const daysAgoIso = (days: number) => new Date(Date.now() - days * 24 * 60 * 60 * 1000).toISOString();

const shared = {
  customerProfileId: DEMO_CUSTOMER_PROFILE_ID,
  customerProfileName: 'Acme Mobile Co.',
  createdByEmail: 'demo-admin@app-doctor.io',
  createdByUserId: 9101
};

export const DEMO_APPS: AppResponse[] = [
  {
    ...shared,
    id: 8001,
    name: 'Acme Shopping',
    platform: 'BOTH',
    isActive: true,
    packageName: 'com.acmemobile.shopping',
    bundleId: 'com.acmemobile.shopping',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.acmemobile.shopping',
    appStoreUrl: 'https://apps.apple.com/app/acme-shopping/id1234567890',
    googlePlayConnectionStatus: 'SYNCED',
    firebaseConnectionStatus: 'SYNCED',
    googlePlayDeveloperId: 'acme-mobile-dev',
    googlePlayServiceAccountEmail: 'gp-sync@acme-mobile.iam.gserviceaccount.com',
    googlePlayLastSync: daysAgoIso(0.2),
    firebaseProjectId: 'acme-shopping-prod',
    firebaseServiceAccountEmail: 'firebase-sync@acme-shopping-prod.iam.gserviceaccount.com',
    firebaseLastSync: daysAgoIso(0.1),
    ga4PropertyId: '398471234',
    androidGa4StreamId: '1938471234',
    iosGa4StreamId: '1938471235',
    googleCloudProjectId: 'acme-shopping-prod',
    lastSync: daysAgoIso(0.1),
    createdAt: daysAgoIso(200),
    updatedAt: NOW_ISO
  },
  {
    ...shared,
    id: 8002,
    name: 'Acme Loyalty',
    platform: 'ANDROID',
    isActive: true,
    packageName: 'com.acmemobile.loyalty',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.acmemobile.loyalty',
    googlePlayConnectionStatus: 'SYNCED',
    firebaseConnectionStatus: 'READY',
    googlePlayDeveloperId: 'acme-mobile-dev',
    googlePlayServiceAccountEmail: 'gp-sync@acme-mobile.iam.gserviceaccount.com',
    googlePlayLastSync: daysAgoIso(1),
    firebaseProjectId: 'acme-loyalty-prod',
    ga4PropertyId: '398471300',
    androidGa4StreamId: '1938471300',
    googleCloudProjectId: 'acme-loyalty-prod',
    lastSync: daysAgoIso(1),
    createdAt: daysAgoIso(140),
    updatedAt: NOW_ISO
  },
  {
    ...shared,
    id: 8003,
    name: 'Acme Delivery Partner',
    platform: 'IOS',
    isActive: true,
    bundleId: 'com.acmemobile.deliverypartner',
    appStoreUrl: 'https://apps.apple.com/app/acme-delivery-partner/id1234567891',
    firebaseConnectionStatus: 'SYNCED',
    firebaseProjectId: 'acme-delivery-partner',
    firebaseServiceAccountEmail: 'firebase-sync@acme-delivery-partner.iam.gserviceaccount.com',
    firebaseLastSync: daysAgoIso(0.5),
    ga4PropertyId: '398471350',
    iosGa4StreamId: '1938471350',
    lastSync: daysAgoIso(0.5),
    createdAt: daysAgoIso(75),
    updatedAt: NOW_ISO
  },
  {
    ...shared,
    id: 8004,
    name: 'Acme Rewards (Beta)',
    platform: 'ANDROID',
    isActive: false,
    packageName: 'com.acmemobile.rewardsbeta',
    playStoreUrl: 'https://play.google.com/store/apps/details?id=com.acmemobile.rewardsbeta',
    googlePlayConnectionStatus: 'FAILED',
    googlePlayConnectionLastError: 'Service account key expired — reconnect to resume syncing.',
    firebaseConnectionStatus: 'NOT_CONFIGURED',
    googlePlayDeveloperId: 'acme-mobile-dev',
    googlePlayLastSync: daysAgoIso(9),
    lastSync: daysAgoIso(9),
    createdAt: daysAgoIso(30),
    updatedAt: NOW_ISO
  }
];
